<app-message [service]="messageService"></app-message>


<form id="charging-station-info-form" *ngIf="entity">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-xl-8 card mt-2">
        <div *ngIf="this.entity?.chargingPoints?.length>=1" class="row card-body">
          <ng-container *ngTemplateOutlet="multiple"></ng-container>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <ng-container *ngTemplateOutlet="helpText"></ng-container>

          </div>
        </div>
        <div class="row card">
          <div class="col-12 card-body text-center fs-5 fw-normal" style="line-height:2.75rem;">
            <span class="btn-light p-2 m-2 form-text fs-6" style="word-break:keep-all"
                  *ngIf="this.entity?.profile?.isErk">
              <i class="ri-award-fill pe-2"></i>Eichrechtskonform
            </span>
            <span class="btn-light p-2 m-2 form-text fs-6" style="word-break:keep-all"
                  *ngIf="this.entity?.profile?.isOcpp16">
              <i class="ri-server-fill pe-2"></i>OCPP&nbsp;1.6
            </span>
            <span class="btn-light p-2 m-2 form-text fs-6" style="word-break:keep-all">
              <i class="ri-git-fork-fill pe-2"></i>{{this.getChargingPointCountText()}}
            </span>
            <span class="btn-light p-2 m-2 form-text fs-6" style="word-break:keep-all"
                  *ngIf="this.entity?.profile?.isMobile">
              <i class="ri-base-station-line pe-2"></i>4G
            </span>
            <span class="btn-light p-2 m-2 form-text fs-6" style="word-break:keep-all" *ngIf="!isAvailable">
              <i class="ri-lock-fill pe-2"></i>Gesperrt
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 pt-2 col-xl-4 g-0 gx-xl-4">
        <div class="row">
          <div class="col-12">
            <div class="card h-100">
              <div class="card-header">
                Lademodus
              </div>
              <div class="card-body">
                <div *ngIf="!this.isUser">
                  <div class="row text-left">
                    <div class="col-12 mb-1">
                      <button class="btn {{this.entity?.isFreeCharge?'btn-active ':'btn-primary '}} "
                        (click)="changeMode('free');"
                        ngbTooltip="'Wenn kostenloses Laden eingeschaltet ist, wird keine Autorisierung und keine RFID-Karte benötigt.'">
                        <i class="ri-plug-fill" width="24"></i>
                      </button>
                      &nbsp;Kostenloses Laden
                    </div>
                    <div class="col-12 mb-1">
                      <button class="btn {{this.entity?.isPrivateCharge?'btn-active ':'btn-primary '}}"
                        (click)="changeMode('authorize');"
                        ngbTooltip="Nur autorisierte Benutzer können einen Ladevorgang mittels RFID-Karte oder über CUBOS.Connect starten.">
                        <i class="ri-rfid-line" width="24"></i>
                      </button>
                      &nbsp;Autorisiertes Laden
                    </div>
                    <div class="col-12" *ngIf="this.doAllChargingPointsHavePublicKeys()">
                      <span class="d-inline"
                        ngbTooltip="'Öffentliches Laden ist nur möglich wenn ein Öffentlicher Schlüssel vom Ladepunkt bereitgestellt wird.'">
                        <button
                          class="btn {{this.entity?.isPublicCharge?'btn-active ':'btn-primary '}} {{ this.doAllChargingPointsHavePublicKeys()?'':'bg-secondary'}}"
                          (click)="changeMode('public');" [disabled]="!this.doAllChargingPointsHavePublicKeys()">
                          <i class="ri-money-euro-box-line" width="24"></i>
                        </button>
                      </span>
                      &nbsp;<span class="{{ this.doAllChargingPointsHavePublicKeys()?'':'text-muted' }}">Autorisiertes & QR-Code-Laden</span>
                    </div>
                  </div>
                  <div *ngIf="this.doAllChargingPointsHavePublicKeys()">
                    <div *ngIf="this.showFreeChargeText" class="form-text m-0 text-center pt-3"
                      i18n="@@FreeChargeUnavailableDueToStatus">
                      Kostenloses laden kann nur aktiviert werden, solange sich die Ladestation <b>nicht</b> im Status
                      <em>Lädt</em>
                      oder<br /> <em>nicht verfügbar/offline/Fehler</em> befindet.
                    </div>
                    <div *ngIf="this.currentChargeMode == 'free'" class="form-text text-center pt-3 "
                      i18n="@@FreeChargeActivated">
                      Kostenloses Laden ist derzeit aktiviert, es wird keine Autorisierung benötigt.
                    </div>
                    <div *ngIf="this.currentChargeMode != 'free'" class="form-text text-center pt-3"
                      i18n="@@ChargingDemandsAuthorization">
                      Zum Laden wird eine Autorisierung benötigt.
                    </div>
                  </div>
                </div>

                <div *ngIf="this.isUser" class="chargeMode text-center mt-2">
                  <div for="freeMode" *ngIf="this.currentChargeMode == 'free'" i18n="@@ChargingStationFreeChargeLabel">
                    Kostenloses Laden
                  </div>
                  <div for="privateMode" *ngIf="this.currentChargeMode == 'authorize'"
                    i18n="@@ChargingStationPrivateChargeLabel">
                    Autorisiertes Laden
                  </div>
                  <div for="publicMode" *ngIf="this.currentChargeMode == 'public'"
                    i18n="@@ChargingStationPublicChargeLabel">
                    Autorisiertes &amp; QR-Code-Laden
                  </div>
                  <div *ngIf="this.currentChargeMode == 'free'" class="form-text" i18n="@@FreeChargeActivated">
                    Kostenloses Laden ist derzeit aktiviert, es wird keine Autorisierung benötigt.
                  </div>
                  <div *ngIf="this.currentChargeMode != 'free'" class="form-text" i18n="@@ChargingDemandsAuthorization">
                    Zum Laden wird eine Autorisierung benötigt.
                  </div>
                </div>

                <label class="details-profile-mode" i18n="@@ChargingProfileLabel"
                  *ngIf="this.hasBlackBox">Ladeprofil</label>
                <div style="padding: .375rem;" ngbTooltip="Ladeprofile ermöglichen kosteneffizientes Laden"
                  *ngIf="this.hasBlackBox">
                  <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="chargingProfile"
                    aria-describedby="chargingProfileText" checked />
                  <label for="chargingProfile" i18n="@@chargingProfileLabel">
                    Das Laden mit verschiedenen Ladeprofilen zulassen
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pt-2 mt-xl-2" *ngIf="this.doAllChargingPointsHavePublicKeys()">
            <div class="col-12">
              <div class="card">
                <div class="card-header fw-semibold">QR-Code-Link</div>
                <div class="card-body">
                  <div *ngIf="entity.isPublicCharge" class="d-flex">
                    <textarea readonly disabled class="form-control" value="{{ qrCodeUrl }}"></textarea>
                    <span class="input-group-append">
                      <button class="btn btn-primary rounded-0 rounded-top" type="button" [cdkCopyToClipboard]="qrCodeUrl"
                        (mouseup)="copysuccess('QR-Code')" ngbTooltip="Wert kopieren">
                        <app-svg source="icons/feather/copy" height="18"></app-svg>
                      </button>
                      <a class="btn btn-primary rounded-0 rounded-bottom" [href]="qrCodeUrl" [target]="_blank" ngbTooltip="Link aufrufen">
                        <app-svg source="icons/feather/external-link" height="18"></app-svg>
                      </a>
                    </span>
                  </div>
                  <div *ngIf="!entity.isPublicCharge" class="d-flex">
                    <p>Für diese Ladestation wurde kein QR-Code erstellt.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<ng-template #multiple>
  <div class="col-12 order-1 col-lg-8 order-lg-0 pt-3 text-left" *ngIf="this.entity">
    <div *ngFor="let cp of this.entity?.chargingPoints; index as i" class="d-flex align-items-center">
      <ng-container *ngTemplateOutlet="chargepointButton, context:{$implicit: cp}"></ng-container>
    </div>
  </div>
  <div class="col-12 order-0 col-lg-4 order-lg-1 col-lg-4">
    <img src="{{ this.entity.model?.pictureUri }}" class="img-fluid border border-1 rounded-2 shadow-sm" />
  </div>
</ng-template>
<ng-template #chargepointButton let-cp>
  <div class="btn-group w-100 mb-2 text-left" role="group" aria-label="Basic example">
    <span class="text-light p-2 rounded me-1" style="background-color: #212529">{{cp?.connectorId}}</span>
    <button class="btn p-2 button hero blue me-1" (click)="setChargingStationReserved(cp?.connectorId)"  style="max-width:40px;"
            *ngIf="showReservationBtn[cp?.connectorId]" ngbTooltip="Diesen Ladepunkt für 30 Minuten reservieren">
      <span class="lh-sm"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M7 3V1H9V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V9H20V5H17V7H15V5H9V7H7V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7ZM17 12C14.7909 12 13 13.7909 13 16C13 18.2091 14.7909 20 17 20C19.2091 20 21 18.2091 21 16C21 13.7909 19.2091 12 17 12ZM11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16ZM16 13V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V13H16Z"></path></svg></span>
    </button>
    <button class="btn p-2 button hero blue me-1" ngbTooltip="Reservierung aufheben" style="max-width:40px;" (click)="cancelChargingStationReservation(cp?.connectorId)"
            *ngIf="showCancelReservationBtn[cp?.connectorId]">
      <span class="lh-sm"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M9 3V1H7V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9ZM4 10H20V19H4V10ZM4 5H7V6H9V5H15V6H17V5H20V8H4V5ZM9.87862 10.9644L12 13.0858L14.1212 10.9644L15.5355 12.3785L13.4142 14.5001L15.5354 16.6212L14.1213 18.0354L12 15.9143L9.87855 18.0354L8.46442 16.6211L10.5857 14.5001L8.46436 12.3785L9.87862 10.9644Z"></path></svg></span>
    </button>
    <button type="button" class="btn p-2 button btn-block d-inline-block {{bgcolor[cp?.connectorId]}}" aria-describedby="ButtonCharging"
             (click)="openRemoteStartStopDialog(this.canCharging[cp?.connectorId], cp?.connectorId)">
      <span class="lh-sm">{{ ButtonText[cp?.connectorId]}} </span>
    </button>
    <ng-container *ngTemplateOutlet="remoteStartInfo"></ng-container>
  </div>
</ng-template>

<ng-template #remoteStartInfo class="form-text">
  <span i18n="@@RemoteStartChargingInfo">&nbsp;</span>
</ng-template>

<ng-template #helpTextr class="form-text">
  <span *ngIf="this.customer
    && entity?.chargingPoints[0]?.statusId == 2
    || entity?.chargingPoints[0]?.statusId == 5
    || entity?.chargingPoints[0]?.statusId == 6
    || entity?.chargingPoints[1]?.statusId == 2
    || entity?.chargingPoints[1]?.statusId == 5
    || entity?.chargingPoints[1]?.statusId == 6" class="form-text"
    i18n="@@RemoteStartChargingPricingInfo"><strong>Hinweis</strong>:&nbsp;
    Bei einem manuellem Freigeben eines Ladevorgangs können die kWh nicht in Rechnung gestellt werden.
  </span>
</ng-template>
<ng-template #helpTextl class="form-text">
  <span *ngIf="this.customer
    && entity?.chargingPoints[0]?.statusId == 2
    || entity?.chargingPoints[0]?.statusId == 5
    || entity?.chargingPoints[0]?.statusId == 6
    || entity?.chargingPoints[1]?.statusId == 2
    || entity?.chargingPoints[1]?.statusId == 5
    || entity?.chargingPoints[1]?.statusId == 6" class="form-text" i18n="@@RemoteStartChargingPricingInfo">
    <strong>Hinweis</strong>:&nbsp;
    Bei einem manuellem Freigeben eines Ladevorgangs können die kWh nicht in Rechnung gestellt werden.
  </span>
</ng-template>

<ng-template #remoteStopInfo class="form-text">
  <span i18n="@@RemoteStopChargingInfo">Beendet den aktuellen Ladevorgang.</span>
</ng-template>

<ng-template #remoteDisabledInfo class="form-text">
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 1" i18n="@@RemoteDisabledNotRegistered">
    Die Ladestation ist nicht registriert.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 4" i18n="@@RemoteDisabledNotReady">
    Der Ladepunkt ist nicht bereit.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 5" i18n="@@RemoteDisabledTransactionEndByChargingStation">
    Der Ladepunkt beendet den aktuellen Ladevorgang.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 8" i18n="@@RemoteDisabledTransactionEndByVehicle">
    Der Ladevorgang wurde vom Fahrzeug angehalten.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 9" i18n="@@RemoteDisabledTransactionStopped">
    Der Ladevorgang ist angehalten.
  </span>
  <span *ngIf="!isAvailable || entity?.chargingPoints[0]?.statusId == 10" i18n="@@RemoteDisabledNotAvailable">
    Der Ladepunkt ist nicht verfügbar.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 11" i18n="@@RemoteDisabledNoConnection">
    Die Ladestation hat keine Verbindung.
  </span>
</ng-template>

<ng-template #remoteDisabledInfoR class="form-text">
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 1" i18n="@@RemoteDisabledNotRegistered">
    Die Ladestation ist nicht registriert.
  </span>
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 4" i18n="@@RemoteDisabledNotReady">
    Der Ladepunkt ist nicht bereit.
  </span>
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 5" i18n="@@RemoteDisabledTransactionEndByChargingStation">
    Der Ladepunkt beendet den aktuellen Ladevorgang.
  </span>
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 8" i18n="@@RemoteDisabledTransactionEndByVehicle">
    Der Ladevorgang wurde vom Fahrzeug angehalten.
  </span>
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 9" i18n="@@RemoteDisabledTransactionStopped">
    Der Ladevorgang ist angehalten.
  </span>
  <span *ngIf="!isAvailable || entity?.chargingPoints[1]?.statusId == 10" i18n="@@RemoteDisabledNotAvailable">
    Der Ladepunkt ist nicht verfügbar.
  </span>
  <span *ngIf="entity?.chargingPoints[1]?.statusId == 11" i18n="@@RemoteDisabledNoConnection">
    Die Ladestation hat keine Verbindung.
  </span>
</ng-template>
